export const SUBSCRIPTION_TYPES = [
  {
    value: 'SUBSCRIPTION_PLAN_TYPE_CASH',
    label: 'نقدی',
  },
  {
    value: 'SUBSCRIPTION_PLAN_TYPE_BLOCK',
    label: 'مسدودی',
  },
  {
    value: 'SUBSCRIPTION_PLAN_TYPE_POST_PAID',
    label: 'پس پرداخت',
  },
];

export const SETTLEMENT_PERIOD_TYPE = [
  {
    value: 'SUBSCRIPTION_PLAN_SETTLEMENT_PERIOD_TYPE_YEARLY',
    label: 'سالانه',
    shortLabel: 'ساله',
  },
  {
    value: 'SUBSCRIPTION_PLAN_SETTLEMENT_PERIOD_TYPE_MONTHLY',
    label: 'ماهانه',
    shortLabel: 'ماهه',
  },
  {
    value: 'SUBSCRIPTION_PLAN_SETTLEMENT_PERIOD_TYPE_DAILY',
    label: 'روزانه',
    shortLabel: 'روزه',
  },
  {
    value: 'SUBSCRIPTION_PLAN_SETTLEMENT_PERIOD_TYPE_WEEKLY',
    label: 'هفتگی',
    shortLabel: 'هفتگی',
  },
];

export const DEFAULT_SUBSCRIPTION_TYPE = 'SUBSCRIPTION_PLAN_TYPE_CASH';

export const PERIOD_TYPES = [
  {
    value: 'SUBSCRIPTION_PLAN_PERIOD_TYPE_DAILY',
    label: 'روز',
    shortLabel: 'روزه',
  },
  {
    value: 'SUBSCRIPTION_PLAN_PERIOD_TYPE_MONTHLY',
    label: 'ماه',
    shortLabel: 'ماهه',
  },
  {
    value: 'SUBSCRIPTION_PLAN_PERIOD_TYPE_YEARLY',
    label: 'سال',
    shortLabel: 'ساله',
  },
];

export const STATUSES = [
  {
    value: 'SUBSCRIPTION_NOT_VERIFY',
    label: 'در انتظار تایید (تایید نشده)',
  },
  {
    value: 'SUBSCRIPTION_CONFIRM',
    label: 'تایید شده',
  },
  {
    value: 'SUBSCRIPTION_TIMEOUTED',
    label: 'اتمام مهلت فعال‌سازی',
  },
  {
    value: 'SUBSCRIPTION_EXPIRED',
    label: 'منقضی شده',
  },
  {
    value: 'SUBSCRIPTION_REVOKED',
    label: 'لغو شده توسط کسب‌وکار',
  },
  {
    value: 'SUBSCRIPTION_REJECTED',
    label: 'رد شده',
  },
];
